import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { AuthContext } from '../../../../context/AuthProvider';
import { Page } from '../../../../types';
import { useOnAppInit } from '../../../../hooks/useOnAppInit';
import NewDashboard from './NewDashboard';
import OldDashboard from './OldDashboard';
import InfoMainPage from '../../../info/InfoMainPage';

const DashboardPage: Page = () => {
  const user = useContext(AuthContext);

  useOnAppInit();

  if (!user || user.pk == null) {
    return <Navigate to="/sign-in/?next=/" />;
    // TODO: Hide for now
    return <InfoMainPage />;
  }

  if (user.editor_admin) {
    window.location.replace('/admin');
    return <Navigate to="/404" />;
  }

  return (
    <>
      {user.namespaces.includes('hr') ||
      user.namespaces.includes('bih') ||
      user.namespaces.includes('tennessee') ||
      user.flags.includes('new-dashboard') ? (
        <NewDashboard />
      ) : (
        <OldDashboard />
      )}
    </>
  );
};

DashboardPage.getRoute = () => '/';

export default DashboardPage;
